import axiosInstance from "../../../services/axiosInstance";
import axiosInstanceMultipart from "../../../services/axiosInstanceMultipart";
export const getAddresses = async (params) => {
    const response = await axiosInstance.get(`addresses` , {params});
    return response.data;
};

export const storeRequest = async (request) => {
    const response = await axiosInstanceMultipart.post(`service-requests` , request);
    return response.data;
};

export const getRequests = async (params) => {
    const response = await axiosInstance.get(`service-requests` , {params});
    return response.data;
};

export const getRequest = async (id , params = {}) => {
    const response = await axiosInstance.get(`service-requests/${id}` , {params});
    return response.data;
};

export const payRequest = async (request) => {
    const response = await axiosInstanceMultipart.post(`payments/handle-payments-requests` , request);
    return response.data;
};